'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { usePopover, usePreventScroll, Overlay } from '@react-aria/overlays';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { useSwanPopover } from './popover.context.js';
import { useInternalDialogConfigContext as g } from '../modal-dialog/dialog.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(o = 0; o < a.length; o++)t = a[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, a = Object.keys(e);
    for(o = 0; o < a.length; o++)t = a[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let b = parseInt(tokensRaw.SwanSemSpace2) || 4, u = tokensRaw.SwanBaseFontLineHeight500 * parseFloat(tokensRaw.SwanBaseFontSize100), f = 4.25 * (u + 2 * parseFloat(tokensRaw.SwanCompListboxOptionPaddingVertical) + parseFloat(tokensRaw.SwanSemSpace1)) + parseFloat(tokensRaw.SwanCompListboxPadding);
const PopoverContentInternal = renderWithRef('PopoverContent', {}, (p, i)=>{
    let { children: u, offset: m = b, isNonModal: _ = false, portalContainer: j, hideArrow: w = false, fullBleed: y, className: O, placement: v = 'top', disableContainerPadding: g$1 } = p, P = _object_without_properties(p, [
        "children",
        "offset",
        "isNonModal",
        "portalContainer",
        "hideArrow",
        "fullBleed",
        "className",
        "placement",
        "disableContainerPadding"
    ]), { popoverRef: h, triggerRef: S, overlayProps: x, overlayState: C, modes: k, maxHeight: D = f } = useSwanPopover(), { inModal: F, portalRef: M, dialogRef: L } = g(), N = null != j ? j : F && M.current ? M.current : void 0, { popoverProps: B, underlayProps: E, placement: I, arrowProps: K } = usePopover({
        popoverRef: h,
        triggerRef: S,
        placement: v,
        offset: m,
        isNonModal: _,
        boundaryElement: F && L.current || void 0,
        containerPadding: g$1 ? 0 : void 0,
        maxHeight: D
    }, C), z = assignRefs(i, h), A = new Set([
        ROOT_CLASSNAMES.base,
        'swan-popover'
    ]);
    return y && A.add('swan-popover-skin-full-bleed'), k.hasDarkMode && A.add(ROOT_CLASSNAMES.darkMode), k.hasCompactMode && A.add(ROOT_CLASSNAMES.compactMode), O && A.add(O), usePreventScroll({
        isDisabled: false
    }), jsxs(Overlay, _object_spread_props(_object_spread({}, x), {
        portalContainer: N,
        children: [
            !_ && jsx("div", _object_spread_props(_object_spread({}, E), {
                className: "swan-popover-underlay"
            })),
            jsxs(RenderComp, {
                root: "div",
                forwardedRef: z,
                props: _object_spread_props(_object_spread({}, P, B), {
                    'data-placement': w ? void 0 : I
                }),
                classNames: A,
                children: [
                    w ? null : jsx("svg", _object_spread_props(_object_spread({}, K), {
                        className: "swan-popover-arrow",
                        viewBox: "0 0 24 24",
                        children: jsx("path", {
                            d: "M0 0 L12 12 L24 0"
                        })
                    })),
                    u
                ]
            })
        ]
    }));
});

export { PopoverContentInternal };
